import styled from 'styled-components'

export const DisplayHeaderContainerStyles = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.8rem;
`
